import React, { Component } from "react";
import {
  Box,
  Table,
  TableBody,
  TableHeader,
  TableRow,
  Heading,
  Text,
  TableCell
} from "grommet";
import LogbookContainer from "./logbooks/LogbookContainer";

export class LogbookTable extends Component {
  state = {
    tableRows: []
  };

  updateRowData = () => {
    // console.log("logbooktable props", this.props);
  };

  componentWillMount = () => {
    this.updateRowData();
  };

  render() {
    const logbooks = this.props.shiftData.Building.Logbooks;
    const debugToggle = true;
    if (typeof logbooks === "object" && logbooks.length !== 0 && debugToggle) {
      return (
        <Box>
          {logbooks.map((logbook, index) => {
            return (
              <Box direction="column" alignContent="center">
                <Box align="center" justify="center">
                  <Heading size="small" level="4" textAlign="center">
                    {logbook.logbookTitle}
                  </Heading>
                </Box>
                <LogbookContainer
                  logbook={logbook}
                  key={index}
                  firebase={this.props.firebase}
                ></LogbookContainer>
              </Box>
            );
          })}
        </Box>
      );
    } else {
      return <div>No Logbooks</div>;
    }
  }
}

export default LogbookTable;
